import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { ReportMetadata, ReportYear, ReportSchedule, ReportsForToday, ReportScheduleForHome } from '../../models/report.model';
import { delay, finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReleaseScheduleComponent } from '../release-schedule/release-schedule.component'
import { TodayReportComponent } from '../today-report/today-report.component'
import { PostByCountryComponent } from '../post-by-country/post-by-country.component';
import { AuthUserService } from '../../services/appInitialization/authUser.service';
import { User, Location } from '../../models/user.model';
import { LookupService } from '../../services/lookups/lookup.service';
import { environment } from '../../../environments/environment';
import { PercentageReportByCountryComponent } from '../percentage-report-by-country/percentage-report-by-country.component';
import { TopFiveReportCategoriesComponent } from '../top-five-report-categories/top-five-report-categories.component';

@Component({
  selector: 'app-externaluserhome',
  templateUrl: './externaluserhome.component.html',
  styleUrls: ['./externaluserhome.component.css']
})
export class ExternaluserhomeComponent implements OnInit {
  todayReportData:ReportsForToday[];
  reportScheduleData:ReportScheduleForHome[];
  user: User = this.authUserService._user;
  countryList: Location[];
  selectedCountryId: number;
  countryName: string;
  publishTime: Date;
  today: Date = new Date();
  @ViewChild(ReleaseScheduleComponent) releaseSchedule: ReleaseScheduleComponent;
  @ViewChild(TodayReportComponent) todayReport: TodayReportComponent;
  @ViewChild(PostByCountryComponent) reportCountry: PostByCountryComponent;
  @ViewChild(PercentageReportByCountryComponent) percentageReport: PercentageReportByCountryComponent;
  @ViewChild(TopFiveReportCategoriesComponent) topFiveReport: TopFiveReportCategoriesComponent;

  constructor(private reportService:ReportService,
    private spinner: NgxSpinnerService,
    private authUserService: AuthUserService,
    private lookupService: LookupService) { }

    ngOnInit() {
      this.publishTime = new Date();
      this.publishTime.setHours(parseInt(environment.reportPublishTime.split(':')[0]));
      this.publishTime.setMinutes(parseInt(environment.reportPublishTime.split(':')[1]));
      this.publishTime.setSeconds(parseInt(environment.reportPublishTime.split(':')[2]));
      this.publishTime.setHours(this.publishTime.getHours() + (this.checkDST ? 4 : 5) - this.publishTime.getTimezoneOffset()/60);
      if(new Date() > this.publishTime){
        var todayReport = document.getElementById("today-report-container");
        todayReport.style.height = "102.5%";
      }

      this.reportService.getReportsForToday(this.user.id, 10000)
      .pipe(finalize(()=>this.spinner.hide()))
      .subscribe((data:ReportsForToday[])=>{
        if(data.length>0){
          this.todayReportData = data.filter(x => x.isPublic = true);
        }
      });

      this.reportService.getReportScheduleForHome(this.user.id, 10000)
      .pipe(finalize(()=>this.spinner.hide()))
      .subscribe((data:ReportScheduleForHome[])=>{
        if(data.length>0){
          this.reportScheduleData = data;
        }
      });

      this.lookupService.getAllCountries$()
      .pipe(finalize(()=>this.spinner.hide()))
      .subscribe((data:Location[])=>{
        if(data.length>0){
          this.countryList = data.filter(x => x.fasCountryCode != null && x.locationCode != null && x.locationTypeId == 6);
          this.onChangeCountry(this.countryList.find(x => x.locationName == 'Canada').id);
        }
      });

    }
  
    refreshTodayReport(){
      this.spinner.show();
      this.reportService.getReportsForToday(this.user.id, 10000)
      .pipe(finalize(()=>this.spinner.hide()))
      .subscribe((data:ReportsForToday[])=>{
        if(data.length>0){
          this.todayReportData = data;
        }
      });
    }

    refreshReportSchedule(){
      this.spinner.show();
      this.reportService.getReportScheduleForHome(this.user.id, 10000)
      .pipe(finalize(()=>this.spinner.hide()))
      .subscribe((data:ReportScheduleForHome[])=>{
        if(data.length>0){
          this.reportScheduleData = data;
        }
      });
    }
    
    onChangeCountry(countryId){
      this.countryName = this.countryList.find(x=>x.id==countryId).locationName;
      this.selectedCountryId = countryId;
      this.reportCountry.loadCountry(countryId);
      this.percentageReport.getCountryReportRatio(countryId, this.user.id);
      this.topFiveReport.getTopFiveCategories(countryId, this.user.id);
    }

    checkDST(){
      var january = new Date(this.today.getFullYear(), 0, 1).getTimezoneOffset();
      var july = new Date(this.today.getFullYear(), 6, 1).getTimezoneOffset();
      return Math.max(january, july) != this.today.getTimezoneOffset();
    }

}
